module.exports = __webpack_public_path__ + "static/2022-9e8078e009d464c7a90548bd47a72125.png";